import React from "react";

/** Generic OAuth buttons block — shared by Signup and Login pages. */
export default function OAuthButtons({ onGoogle, disabled = false, testidPrefix = "oauth" }) {
    return (
        <div className="space-y-3">
            <button
                type="button"
                onClick={onGoogle}
                disabled={disabled}
                data-testid={`${testidPrefix}-google`}
                className="w-full flex items-center justify-center gap-3 bg-white hover:bg-zinc-100 text-[#1f1f1f] px-6 py-3.5 rounded-md font-semibold transition-colors disabled:opacity-60"
            >
                <svg className="w-5 h-5" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
                    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.4 6.3 14.7z" />
                    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.3-7.2 2.3-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
                    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.6l6.2 5.2C41.9 34.6 44 29.7 44 24c0-1.3-.1-2.3-.4-3.5z" />
                </svg>
                Continue with Google
            </button>
            <button
                type="button"
                disabled
                data-testid={`${testidPrefix}-linkedin`}
                className="w-full flex items-center justify-center gap-3 bg-zinc-900 border border-zinc-800 text-zinc-400 px-6 py-3.5 rounded-md font-semibold cursor-not-allowed relative"
                title="LinkedIn OAuth — coming soon"
            >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#0A66C2">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                Continue with LinkedIn
                <span className="absolute right-3 text-[10px] font-mono uppercase tracking-widest text-zinc-500">Soon</span>
            </button>
            <button
                type="button"
                disabled
                data-testid={`${testidPrefix}-microsoft`}
                className="w-full flex items-center justify-center gap-3 bg-zinc-900 border border-zinc-800 text-zinc-400 px-6 py-3.5 rounded-md font-semibold cursor-not-allowed relative"
                title="Microsoft OAuth — coming soon"
            >
                <svg className="w-5 h-5" viewBox="0 0 23 23">
                    <path fill="#f25022" d="M1 1h10v10H1z" />
                    <path fill="#00a4ef" d="M1 12h10v10H1z" />
                    <path fill="#7fba00" d="M12 1h10v10H12z" />
                    <path fill="#ffb900" d="M12 12h10v10H12z" />
                </svg>
                Continue with Microsoft
                <span className="absolute right-3 text-[10px] font-mono uppercase tracking-widest text-zinc-500">Soon</span>
            </button>
        </div>
    );
}
